// src/components/ErrorComponent.js
import React from 'react';
import './styles/ErrorComponent.css';// Archivo CSS para estilos opcionales

const ErrorComponent = ({ message }) => {
  return (
    <div className="error-component">
      <h2>Error</h2>
      <p>{message}</p>
    </div>
  );
};

export default ErrorComponent;
